module.exports = __webpack_public_path__ + "static/media/area.c25b627f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/generalInformation/area.svg
// module id = 301
// module chunks = 0